
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/countries",
      function () {
        return require("private-next-pages/countries/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/countries"])
      });
    }
  